import { c as _c } from "react-compiler-runtime";
import { createAppProvider } from 'marketing-platform-lib/utils/createAppProvider';
import { useStore, useShallow } from 'collaboration-sidebar-common/store/store';
export const {
  AppProvider: CollaborationSidebarProvider,
  useAppValue: useCollaborationSidebarValue
} = createAppProvider();
export function useCollaborationSidebarActions() {
  "use memo";

  return useCollaborationSidebarValue("collaborationSidebarState").actions;
}
export function useCollaborationSidebarStateValue(selector) {
  "use memo";

  const leaderStore = useCollaborationSidebarValue("collaborationSidebarState");
  return useStore(leaderStore, selector);
}
export function useCollaborationSidebarStateShallowValue(selector) {
  "use memo";

  const leaderStore = useCollaborationSidebarValue("collaborationSidebarState");
  return useStore(leaderStore, useShallow(selector));
}
export function useStateValue(key) {
  "use memo";

  const $ = _c(2);
  const leaderStore = useCollaborationSidebarValue("collaborationSidebarState");
  let t0;
  if ($[0] !== key) {
    t0 = state => state[key];
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useStore(leaderStore, t0);
}